//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PROJECT_ROLES from '@/constants/project-roles'
export default {
  props: {
    projectRole: {
      type: Object || null,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedOption: this.projectRole?.employee_type || null,
      cardSelectOptions: [
        { value: PROJECT_ROLES.COLLABORATOR, label: 'Colaborador' },
        { value: PROJECT_ROLES.SUPERVISOR, label: 'Supervisor' },
      ],
    }
  },
  computed: {
    validOptionSelected() {
      return this.cardSelectOptions.some(
        (option) => option.value === this.selectedOption
      )
    },
    isSupervisor() {
      return this.selectedOption === PROJECT_ROLES.SUPERVISOR
    },
    cardSelectOptionsAvailables() {
      if (this.projectRole === null) {
        return [{ value: null, label: '' }, ...this.cardSelectOptions]
      }
      return this.cardSelectOptions
    },
  },
  methods: {
    updateSelectedOption() {
      if (this.projectRole) {
        this.$emit('updateSupervisorCollaborator', {
          id: this.projectRole.id,
          employee_type: this.selectedOption,
          project: this.projectRole.project,
          user: this.projectRole.user,
        })
      }
    },
  },
}
